type TRangeParams = { length: number };

export const range = ({ length }: TRangeParams): number[] => {
  return Array.from({ length: Math.max(0, length) }, (_, i) => i);
};
